import { Grid, Card, CardContent, Typography } from '@rentacenter/racstrap';
import React from 'react';
import BasicInformation from './BasicInformation';
import { Breadcrumb } from '../../shared/Breadcrumb';
import { customerStyles } from '../../customerStyles';
import { useParams } from 'react-router-dom';
import { Params } from '../../../utils/utils';

export const CSInfo = () => {
  const classes = customerStyles();
  const { ticketId } = useParams<Params>();
  return (
    <>
      <Breadcrumb />
      <Grid container>
        <Grid item md={12} className={classes.mtb30}>
          <Card className={classes.card}>
            <CardContent>
              <Grid item md={12}>
                <Typography>
                  <span className={classes.titleInfo}>
                    Incident Information:
                  </span>{' '}
                  <span>{ticketId}</span>
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <BasicInformation />
      </Grid>
    </>
  );
};
